// Types
import {
  LandingOptionsModalFooterHandlersType,
  LandingOptionsModalFooterHandlersBuilderType,
} from './types/landing-options-modal-footer.handlers.type';

const onClickFooterButtonHandler = <T>({
  onContinue,
  selectedMethod,
  setLoading,
}: LandingOptionsModalFooterHandlersBuilderType<T>): void => {
  setLoading(true);
  onContinue(selectedMethod);
};
const LandingOptionsModalFooterHandlers = <T>(
  props: LandingOptionsModalFooterHandlersBuilderType<T>
): LandingOptionsModalFooterHandlersType => ({
  handleOnClickFooterButton: () => onClickFooterButtonHandler(props),
});

export { LandingOptionsModalFooterHandlers };
